export const HAJI_BACKEND_URL = "https://hajibackend.tasheel-tech.workers.dev/";
